// src/components/ServerDownDropDown.jsx
import React from "react";

const ServerDownPopup = ({ isVisible, onRetry }) => {
  if (!isVisible) return null;

  return (
    // Overlay: Fixed, covers screen (inset-0), dark background with opacity, flex centering
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
      {/* Modal: White bg, padding, rounded, shadow */}
      <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm mx-4">
        <h2 className="text-xl font-bold text-gray-800 mb-2">
          ⚠️ Service Unavailable
        </h2>

        <p className="text-gray-600 mb-2">
          We are having trouble connecting to the server.
        </p>

        <p className="text-sm text-gray-500 mb-4">
          Please check your internet connection or try again later.
        </p>

        <button
          className="mt-2 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          onClick={onRetry}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ServerDownPopup;
